import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Team
} from "@velaro/velaro-component-lib";
import useApi from "@/hooks/useApi";
import React, { useState } from "react";
import LoadingSpinner from "@/components/LoadingSpinner";
import useToastAlert from "@/hooks/useToastAlert";
import { Severity } from "@velaro/velaro-component-lib";
import { PrimaryBlueButton } from "@velaro/velaro-component-lib";
import TeamForm from "./TeamForm";
import IconArrowBack2 from "@/icons/IconArrowBack2";

interface Props {
  teamId: number;
  onClose(): void;
  onTeamUpdated(team: Team): void;
}

export default function EditTeamPanel(props: Props) {
  const api = useApi();
  const toastAlert = useToastAlert();
  const [team, setTeam] = React.useState<Team | null>(null);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState("");

  React.useEffect(() => {
    async function fetchTeam() {
      const response = api.messaging.get(`Teams/${props.teamId}`);
      setTeam(await (await response).json());
    }

    fetchTeam();
  }, [api.messaging, props.teamId]);

  async function handleSubmit() {
    setSending(true);
    const response = await api.messaging.put(`Teams/${props.teamId}`, team);
    if (response.ok) {
      const newTeam = await response.json();
      props.onTeamUpdated(newTeam);
      toastAlert.displayToast(Severity.Success, "Team successfully updated.");
    } else {
      const error = await response.json();
      setError(error);
    }
    setSending(false);
  }

  if (!team) {
    return <LoadingSpinner />;
  }
  return (
    <div>
      <div className="flex justify-between">
        <div className="flex cursor-pointer" onClick={() => props.onClose()}>
          <IconArrowBack2 />
          <div className="ml-2 hover:underline">Back to Dashboard</div>
        </div>
        <div className="p-4 flex flex-col">
          {error != "" && (
            <div className="flex flex-row mb-4 text-red-500">{error}</div>
          )}
          {sending ? (
            <div className="ml-auto flex">
              Saving Changes...
              <LoadingSpinner />
            </div>
          ) : (
            <div className="ml-auto flex flex-row">
              <PrimaryBlueButton
                type="submit"
                label="Save Changes"
                onClick={handleSubmit}
              />
            </div>
          )}
        </div>
      </div>
      <div className="flex justify-center items-center h-full">
        <div className="panel bg-white dark:bg-stone-300 rounded-md shadow-md mb-4 p-4 w-1/2">
          <div>
            <div className="flex items-center justify-between">
              <div className="font-medium text-md pb-1">Team Information</div>
              <div className="text-slate-500 text-xs"></div>
            </div>
            <div className="text-slate-600 text-sm pb-2">
              Input team details to streamline collaboration, organization, and
              management within the platform
            </div>
            {/* <hr className="mt-2 mb-4 border-gray-200" /> */}
          </div>
          <div className="px-4">
            <TeamForm
              team={team}
              onChange={(updates) => {
                setTeam(() => ({ ...team, ...updates }));
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
